import { createFileRoute } from "@tanstack/react-router"
import { StoryboardExplorationPageWrapper } from "./-StoryboardExplorationPage"

export const Route = createFileRoute("/storyboard-exploration")({
  component: StoryboardExplorationPageWrapper,
})
